// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inputcssProperty .v-text-field.v-input--is-focused>.v-input__control>.v-input__slot:after {\n  transform: scaleX(1);\n  border: none;\n}\n.inputcssProperty .theme--light.v-text-field>.v-input__control>.v-input__slot:before {\n  border: transparent;\n}\n.buttonConf th{\n  /* min-width: 170px !important; */\n}\n\n/* LidL Requirements ends */\n", ""]);
// Exports
module.exports = exports;
